import { attach } from "effector";
import { $actionSource } from "./actionSource";

export const activateEditorHotkeys = attach({
  source: $actionSource,
  effect: (actionSource) => actionSource.activate(),
});
